import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ElementUI from 'element-ui';
import './assets/css/common.css'
import './utils/rem.js' // 引入 rem 适配
// import './assets/iconfont/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css';
import config from './config'
Vue.prototype.$config = config // 全局可用
// Vue.prototype.$http=axios
Vue.use(VueAxios, axios);
Vue.use(ElementUI)
Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
